import type { ReactNode } from "react";
import { AppstoreOutlined, CalculatorOutlined } from "@ant-design/icons";

import {
  SERVICE_CATEGORY_SECTION_OPTIONS,
  ServiceCategorySection,
} from "features/serviceCategory/model/serviceCategory";
import styles from "./ServiceCategorySectionTabs.module.css";

const SECTION_ICONS: Record<ServiceCategorySection, ReactNode> = {
  GENERAL: <AppstoreOutlined />,
  AGRO_CALCULATOR: <CalculatorOutlined />,
};

type Props = {
  value: ServiceCategorySection;
  onChange: (section: ServiceCategorySection) => void;
};

/** Переключатель раздела категорий услуг. */
export const ServiceCategorySectionTabs = ({ value, onChange }: Props) => (
  <div>
    <div className={styles.tabs} role="tablist">
      {SERVICE_CATEGORY_SECTION_OPTIONS.map((o) => {
        const active = o.value === value;

        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${styles.tab} ${active ? styles.active : ""}`}
            onClick={() => !active && onChange(o.value)}
          >
            <span className={styles.icon}>{SECTION_ICONS[o.value]}</span>
            {o.label}
          </button>
        );
      })}
    </div>
  </div>
);
